import { ENV } from '@configs/env';

/**
 * Turn backend-relative media paths (e.g. `/uploads/chats/...`) into absolute URLs
 * using the domain-aware API base from env (`ENV.API_URL` / VITE tenant URLs).
 */
export function resolveChatMediaUrl(url) {
    if (!url || typeof url !== 'string') return url;
    if (url.startsWith('http://') || url.startsWith('https://') || url.startsWith('data:')) return url;
    if (url.startsWith('blob:') || url.startsWith('file:')) return url;
    if (url.startsWith('mailto:') || url.startsWith('tel:') || url.startsWith('#')) return url;
    /** Protocol-relative URL (//cdn.example.com/...) — do not prepend API origin. */
    if (url.startsWith('//') && url.length > 2 && url[2] !== '/') {
        if (typeof window !== 'undefined') return `${window.location.protocol}${url}`;
        return `https:${url}`;
    }
    const path = url.startsWith('/') ? url : `/${url}`;
    try {
        const apiUrl = ENV.API_URL && ENV.API_URL.trim();
        const origin = apiUrl
            ? new URL(apiUrl).origin
            : typeof window !== 'undefined'
              ? window.location.origin
              : '';
        if (!origin) return path;
        return `${origin}${path}`;
    } catch {
        return url;
    }
}
